export default class dashboardTiles {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/dashboard/widgets/dashboard-tiles.html'),
            controller: DashboardTilesCtrl,
            controllerAs: 'ctrl'
        }
    }
};

class DashboardTilesCtrl {
    constructor(Dashboard) {
        this.dashboardRepo = Dashboard;

        this.showWidgets = true;
        this.statsLoaded = false;

        this.settings = {
            open: true,
            received: true,
            link: false,
            unsubscribed: false
        };

        this.dashboardRepo.statisticsByAccountAndType('open').then((opens) => {
            this.statsLoaded = true;
            this.openData = opens;
        });

        this.dashboardRepo.statisticsByAccountAndType('received').then((sent) => {
            this.statsLoaded = true;
            this.sentData = sent;
        });
    }

    toggleWidgets() {
        this.showWidgets = ! this.showWidgets;
    };


    toggleOpenData() {
        this.settings['open'] = ! this.settings['open'];
    };

    toggleReceivedData() {
        this.settings['received'] = ! this.settings['received'];
    };

    toggleUnsubscriptionData() {
        this.settings['unsubscribed'] = ! this.settings['unsubscribed'];

        if (! this.unsubscribeData && this.settings['unsubscribed']) {
            this.dashboardRepo.statisticsByAccountAndType('unsubscribed').then((unsubscribes) => {
                this.unsubscribeData = unsubscribes;
            });
        }
    };

    toggleLinkData() {
        this.settings['link'] = ! this.settings['link'];

        if (! this.clickData && this.settings['link']) {
            this.dashboardRepo.statisticsByAccountAndType('link').then((clicks) => {
                this.clickData = clicks;
            });
        }
    };
}
